import { ActionDialogProps } from './types';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';
import { Dialog, DialogClose, DialogContent, DialogDescription, DialogTitle } from '@/components/ui/dialog';
import { X } from 'lucide-react';

const ActionDialog = (props: ActionDialogProps) => {
  const {
    actionClassName,
    actionLabel,
    actionVariant,
    cancelLabel,
    cancelVariant,
    children,
    className,
    description,
    icon,
    isOpen,
    onAction,
    onCancel,
    onOpenChange,
    shouldShowClose = true,
    title
  } = props;

  const shouldShowFooter = Boolean(cancelLabel || actionLabel);

  const onClickActionButton = (): void => {
    onAction?.();
    onOpenChange(false);
  };

  const onClickCancelButton = (): void => {
    onCancel?.();
    onOpenChange(false);
  };

  return (
    <Dialog
      onOpenChange={onOpenChange}
      open={isOpen}
    >
      <DialogContent
        className={cn(
          'flex w-[calc(100%-32px)] max-w-[390px] flex-col gap-6 px-4 pb-6 pt-4',
          'rounded-2xl border-border-strong bg-surface shadow-2xl sm:rounded-2xl',
          className
        )}
        hideClose
        {...(description ? {} : { 'aria-describedby': undefined })}
      >
        <div className="flex flex-col gap-2">
          <div className="flex items-center justify-between gap-3">
            <DialogTitle className="flex min-w-0 items-center gap-2 font-sans text-lg font-semibold leading-6 text-foreground">
              {icon ? <span className="shrink-0">{icon}</span> : null}
              <span className="truncate">{title}</span>
            </DialogTitle>
            {shouldShowClose ? (
              <DialogClose asChild>
                <button
                  aria-label="Закрыть"
                  className="inline-flex size-8 shrink-0 items-center justify-center text-muted-foreground rounded-full transition-colors hover:bg-muted hover:text-foreground"
                  type="button"
                >
                  <X
                    className="size-5"
                    strokeWidth={2}
                  />
                </button>
              </DialogClose>
            ) : null}
          </div>
          {description ? (
            <DialogDescription className="font-sans text-sm leading-5 text-muted-foreground">
              {description}
            </DialogDescription>
          ) : null}
        </div>

        {children}

        {shouldShowFooter ? (
          <div className="flex gap-3">
            {cancelLabel ? (
              <Button
                className="flex-1"
                onClick={onClickCancelButton}
                size="md"
                type="button"
                variant={cancelVariant ?? 'tertiary'}
              >
                {cancelLabel}
              </Button>
            ) : null}
            {actionLabel ? (
              <Button
                className={cn('flex-1', actionClassName)}
                onClick={onClickActionButton}
                size="md"
                type="button"
                variant={actionVariant}
              >
                {actionLabel}
              </Button>
            ) : null}
          </div>
        ) : null}
      </DialogContent>
    </Dialog>
  );
};

export default ActionDialog;